import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../../../redux/store";
import { fetchCurrencies } from "./actions";
import {
  addCurrency,
  updateCurrency,
  deleteCurrency,
  setDefaultCurrency,
} from "./reducer";
import MainTable from "../../../../components/mainTable";
import { ModalType } from "../../../../shared/utils/enums";
import { Currency } from "../../../../interfaces/screens/billing";
import { showModal } from "../../../../connected-components/modal/reducer";
import CurrencyEditor from "../../../../components/currencyEditor";
import { getCurrenciesTableColumns } from "../../../../shared/tableColumns/currenciesColumns";

const CurrenciesDashboard = () => {
  const dispatch: AppDispatch = useDispatch();
  const {
    data: currencies,
    loading,
    error,
  } = useSelector((state: RootState) => state.currencies);

  useEffect(() => {
    if (!currencies || currencies.length === 0) {
      dispatch(fetchCurrencies());
    }
  }, [dispatch, currencies]);

  const handleEditCurrency = (currency: Currency) => {
    dispatch(
      showModal({
        title: "Edit Currency",
        type: ModalType.COMPONENT,
        component: <CurrencyEditor currency={currency} isEdit={true} />,
      }),
    );
  };

  const handleAddNewCurrency = () => {
    dispatch(
      showModal({
        title: "Add New Currency",
        type: ModalType.COMPONENT,
        component: <CurrencyEditor isEdit={false} />,
      }),
    );
  };

  const handleDeleteCurrency = (currency: Currency) => {
    dispatch(
      showModal({
        title: "Confirm Deletion",
        message: `Are you sure you want to delete ${currency.name} (${currency.code})?`,
        type: ModalType.QUESTION,
        onConfirm: () => {
          dispatch(deleteCurrency(currency.code));
        },
      }),
    );
  };

  const handleSetDefault = (currency: Currency) => {
    dispatch(setDefaultCurrency(currency.code));
  };

  const columns = getCurrenciesTableColumns({
    onEdit: handleEditCurrency,
    onSetDefault: handleSetDefault,
    onDelete: handleDeleteCurrency,
  });

  return (
    <div className="pt-4">
      <MainTable
        data={currencies}
        columns={columns}
        isLoading={loading}
        onAddNewItemPress={handleAddNewCurrency}
        addButtonLabel="Add Currency"
        showAddButton={true}
      />
      {error && <p className="text-red-500 mt-2">Error: {error}</p>}
    </div>
  );
};

export default CurrenciesDashboard;
